// extracted by mini-css-extract-plugin
export default {"container":"editions-dots_container__3HrVt","item":"editions-dots_item__3Agoa","label":"editions-dots_label__1SCRT"};